import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt, faTrashAlt, faAngleRight, faAnglesRight, faAnglesLeft, faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import TacheUpdate from './TacheUpdate/TacheUpdate';
import {Row, Col} from 'react-bootstrap';
import NothingToDisplay from '../../NothingToDisplay';
import Spinner from '../../Spinner/Spinner';

/**
 * Vue permettant d'ajouter ou de modifier une tâche
 * @param {*} props props
 * @return {JSX}
 */
function TacheView(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTache, setSelectedTache] = useState(null);
  const [isUpdate, setIsUpdate] = useState(true);
  const [isLoading, setIsLoading] = useState(false);


  const openModal = () => {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpen(false);
  };

  /**
   * Permet de modifier une tâche
   * @param {*} tache La tâche à modifier
   */
  function onClickUpdate(tache) {
    setIsUpdate(true);
    openModal();
    setSelectedTache(tache);
  }

  return (
    <div className="chantier-container">
      {isLoading && <Spinner />}
      {isModalOpen && (

        <TacheUpdate isUpdate={isUpdate} selectedTache={selectedTache} setIsLoading={setIsLoading} closeModal={closeModal} setTaches={props.setTaches}/>
      )}

      <h2 className="tache-heading">Liste de Tâches</h2>
      <input
        type="text"
        value={props.searchInput}
        onChange={props.handleSearchInput}
        className="tache-input-hidden"
        placeholder="Barre de recherche" />
      <div className="tache-wrapper">
        <div className="tache-table">
          <div className="tache-search-container">
            <input
              type="text"
              value={props.searchInput}
              onChange={props.handleSearchInput}
              className="tache-input"
              placeholder="Barre de recherche" />
            <div className="tache-pagination-buttons">
              <button
                onClick={() => {
                  setIsUpdate(false);
                  openModal();
                }}
                key="+"
                className="tache-pagination-button">
                Ajouter
              </button>
              {[<FontAwesomeIcon key="1" icon={faAnglesLeft} />,
                <FontAwesomeIcon key="2" icon={faAngleLeft} />,
                <FontAwesomeIcon key="3" icon={faAngleRight} />,
                <FontAwesomeIcon key="4" icon={faAnglesRight} />].map((symbol, index) => {
                const newPage =
              index === 0 ?
                1 :
                index === 1 ?
                props.currentPage - 1 :
                index === 2 ?
                props.currentPage + 1 :
                Math.ceil(props.taches.length / props.pageSize);

                return (
                  <React.Fragment key={index}>
                    <button
                      key={symbol}
                      className="tache-pagination-button"
                      onClick={() => props.handlePageChange(newPage)}
                      disabled={props.isButtonDisabled(symbol)}>
                      {symbol}
                    </button>
                  </ React.Fragment>
                );
              })}

            </div>
          </div>
          {props.displayedTaches.length === 0 ? <NothingToDisplay /> :
      <div className="tache-table">
        <Row className="tache-row tache-header">
          <Col md={6} className="tache-cell">
           Tâches
          </Col>
          <Col md={4} className="tache-cell">
           Couleur
          </Col>
          <Col md={1} className="tache-cell">
          </Col>
        </Row>

        {props.displayedTaches.map((tache, index) => (
          <Row key={index}className="tache-row tache-row-cell-click" >
            <Col md={6} className="tache-cell tache-cell-click" data-title="Tâche" >
              {tache.name}
            </Col>
            <Col md={4} className="tache-cell tache-cell-click" data-title="Couleur" >
              <input type="color" id="body" name="body"
                value={tache.color}
                disabled />
            </Col>
            <Col md={1} className="tache-cell tache-cell-click">
              <FontAwesomeIcon
                className="tache-icon"
                icon={faPencilAlt}
                style={{marginRight: '20px'}}
                onClick={() => onClickUpdate(tache)}/>
              <FontAwesomeIcon
                className="tache-icon"
                icon={faTrashAlt}
                onClick={() => props.supprimer(tache)} />
            </Col>
          </Row>
        ))}
      </div>}
        </div>
      </div>
    </div>
  );
}

export default TacheView;
